import React from 'react';

type IOB = {
  budget: string;
  impacted: boolean;
};

export type PO = {
  id: number;
  submittedBy: string;
  dateRequired: any;
  vendorName: string;
  vendorAddress: string;
  dollarAmount: number;
  location: string;
  agreementNo: string;
  impactedOperatingBudget: string;
  budgetAccountNo: string;
  capitalBudgetAccountNo: string;
  itemBeingPurchased: string;
  renewal: boolean;
  additionalInfo: string;
  quote: string;
  requestId: number;
  status: string;
  timestamp: any;
  budgetImpactAmount: number;
  supportStaff: string;
  poNumber: string;
  notes: string;
  approver: string;
  forPublicSafety: boolean;
  requisitionNumber: string;
  dateInitiated: string;
  dateServicesReceived: string;
};

export const locations = [
  'Arundel Center',
  '2660 Heritage',
  '2662 Heritage',
  '2664 Heritage',
  '2666 Heritage',
  'Commerce Park',
  'Warehouse',
  'Police HQ',
  'Fire HQ',
  'PEG Studio',
  'Arundel Center North',
  'EOC',
];

export const operatingBudgetAccounts = [
  '7251 Centrex Phone',
  '7252 Non-Centrex Phone',
  '7256 Long Distance',
  '7258 Internet',
  '7421 Legal Services',
  '7423 Mgt Services',
  '7439 Prof Services',
  '7601 Telecomm',
  '7603 HW Maint',
  '7605 SW Maint',
  '7611 Fiber Optics',
  '7655 Loaners',
  '7659 Vehicle Ops',
  '7661 Vehicle Repl',
  '8101 Supplies',
  '8103 DP Supplies',
  '8111 Copier',
  '8113 Printing',
  '8122 Mailing',
  '8161 Special Meals',
  '8201 Bldg Supplies',
  '8319 Tools',
  '8331 Other Supplies',
  '8411 Books',
  '8421 Membership',
  '8435 Training',
  '8441 Meals',
  '8443 Lodging',
  '8471 Mileage',
  '8473 Parking',
  '8481 Commercial Transp',
  '8521 Misc',
  'Unknown',
];

export const capitalBudgetAccounts = [
  'C5196 (OIT Enhancements)',
  'C5375 (CATV PEG)',
  'C5654 (Fiber)',
  'C5862 (Broadband)',
  'F5607 (Radio)',
  'F5863 (PS Tech Enh)',
];

export const budgetAccounts = [
  '------- Capital Accounts -------',
  'C5196 (OIT Enhancements)',
  'C5375 (CATV PEG)',
  'C5654 (Fiber)',
  'C593101 (AACPS E-Rate)',
  'C594800 (IT Corporate Infrastructure)',
  'C594900 (Network & Security Enhancements)',
  'C5862 (Broadband)',
  'F5607 (Radio)',
  'F586300 (PS Tech Enh)',
  '------ Operating Accounts ------',
  '7251 Centrex Phone',
  '7252 Non-Centrex Phone',
  '7256 Long Distance',
  '7258 Internet',
  '7421 Legal Services',
  '7423 Mgt Services',
  '7439 Prof Services',
  '7601 Telecomm',
  '7603 HW Maint',
  '7605 SW Maint',
  '7611 Fiber Optics',
  '7655 Loaners',
  '7659 Vehicle Ops',
  '7661 Vehicle Repl',
  '8101 Supplies',
  '8103 DP Supplies',
  '8111 Copier',
  '8113 Printing',
  '8122 Mailing',
  '8161 Special Meals',
  '8201 Bldg Supplies',
  '8319 Tools',
  '8331 Other Supplies',
  '8411 Books',
  '8421 Membership',
  '8435 Training',
  '8441 Meals',
  '8443 Lodging',
  '8471 Mileage',
  '8473 Parking',
  '8481 Commercial Transp',
  '8521 Misc',
  'Unknown',
];

export const supportStaff: { name: string; email: string; color: string }[] = [
  { name: 'Kay Hoffman', email: 'ithoff00@aacounty.org', color: '#ffcfc9' },
  { name: 'Dilnaz Hasim', email: 'ithasi23@aacounty.org', color: '#ffc9f9' },
  { name: 'Laura Abramson', email: 'itabra23@aacounty.org', color: '#ffc8aa' },
  { name: 'Karen Johnson', email: 'itjohn99@aacounty.org', color: '#ffe5a0' },
  { name: 'Schendell Lindsay', email: 'itlind25@aacounty.org', color: '#e3bff6' },
  { name: 'Bonnie Barrett', email: 'itbarr20@aacounty.org', color: '#d4edbc' },
  { name: 'Kim Boozer', email: 'itbooz99@aacounty.org', color: '#bfe1f6' },
  { name: 'Terry Steele', email: 'itstee00@aacounty.org', color: '#c7d0d6' },
  { name: '', email: '', color: '#fff' },
];

export const approvalStaff: { name: string; email: string }[] = [
  { name: 'Jack Martin', email: 'itmart00@aacounty.org' },
  { name: 'Michael Tarquinio', email: 'ittarq23@aacounty.org' },
];

export const impactedOperatingBudgets: string[] = ['FY 25', 'FY 26', 'FY 27', 'FY 28', 'FY 29'];

export const poColumns = [
  {
    column: {
      accessor: 'id',
      type: 'string',
      width: 50,
      Cell: editPurchaseOrder,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'PO Number',
      accessor: 'poNumber',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Requisition
            <br />
            Number
          </div>
        );
      },
      accessor: 'requisitionNumber',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Support Staff',
      accessor: 'supportStaff',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Email Address',
      accessor: 'submittedBy',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      type: 'string',
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Vendor Info',
      accessor: 'vendorName',
      type: 'string',
      resizable: true,
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      Cell: combineVendor,
    },
    type: 'string',
  },
  {
    column: {
      accessor: 'vendorAddress',
      show: false,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Dollar Amount',
      accessor: 'dollarAmount',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      type: 'string',
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Location',
      accessor: 'location',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Agreement
            <br />
            Number
          </div>
        );
      },
      accessor: 'agreementNo',
      type: 'string',
      width: 80,
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Operating
            <br />
            Budget
            <br />
            Account
            <br />
            Number
          </div>
        );
      },
      accessor: 'budgetAccountNo',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Item
            <br />
            Being
            <br />
            Purchased
          </div>
        );
      },
      accessor: 'itemBeingPurchased',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Renewal?',
      accessor: 'renewal',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
      Cell: renewalCheck,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Quote',
      accessor: 'quote',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
      // Cell: getQuote
    },
    type: 'string',
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Capital
            <br />
            Budget
            <br />
            Account
            <br />
            Number
          </div>
        );
      },
      accessor: 'capitalBudgetAccountNo',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      type: 'string',
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Impacted
            <br />
            Operating
            <br />
            Budget
          </div>
        );
      },
      accessor: 'impactedOperating Budget',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: () => <div>Additional Info</div>,
      accessor: 'additionalInfo',
      type: 'string',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Date
            <br />
            Created
          </div>
        );
      },
      accessor: 'timestamp',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      type: 'string',
      Cell: formatDate,
    },
  },
  {
    column: {
      Header: () => {
        return (
          <div>
            Date
            <br />
            Initiated
          </div>
        );
      },
      accessor: 'dateInitiated',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      type: 'string',
      Cell: formatDate,
    },
  },
  {
    column: {
      Header: 'Status',
      accessor: 'status',
      headerStyle: { textAlign: 'center', alignContent: 'center' },
      type: 'string',
    },
    type: 'string',
  },
];

function editPurchaseOrder({ value, row }: any) {
  if (value != null) {
    return (
      <div style={{ textAlign: 'center' }}>
        <a href={`/purchaseOrders/update/po=${row.id}`} style={{ color: 'black' }} className='info'>
          <i className='fa fa-edit' />
        </a>
      </div>
    );
  } else {
    return '';
  }
}

function formatDate({ value, row }: any) {
  if (value != null) {
    return <div style={{ textAlign: 'center' }}>{new Date(row.timestamp).toLocaleDateString()}</div>;
  } else {
    return '';
  }
}

function combineVendor({ value, row }: any) {
  if (value != null) {
    return (
      <div>
        {row.vendorName}
        <br />
        {row.vendorAddress}
      </div>
    );
  } else {
    return '';
  }
}

function renewalCheck({ value, row }: any) {
  if (value !== null) {
    console.log('value: ', value);
    if (value) {
      return (
        <div style={{ textAlign: 'center' }}>
          <i className='fa fa-check' />
        </div>
      );
    }
  }
  return '';
}

//wrapping  style: {'whiteSpace': 'unset'}
